/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProcessingOptions } from './processingOptions';
import { QueuedJobState } from './queuedJobState';
import { SmsMessage } from './smsMessage';
import { SmsProcessingListconfig } from './smsProcessingListconfig';
import { TelcoBillJobState } from './telcoBillJobState';


export interface QueuedSmsJobModel { 
    id: string;
    referenceNumber?: string;
    priority: number;
    message?: string;
    requestSource?: string;
    requestSourcePort?: string;
    requestSoureceFullAddress?: string;
    responseAPI?: string;
    smsType: number;
    parameters?: string;
    industry?: string;
    industryCode?: string;
    apikey?: string;
    username?: string;
    senderId?: string;
    smsMessage?: SmsMessage;
    stateId: number;
    createdUtc: Date;
    scheduledDateUtc?: Date;
    expireAtUtc?: Date;
    stateChangeReason?: string;
    stateChangedUtc?: Date;
    transactionGuidString?: string;
    messageId?: string;
    smSRouteName?: string;
    creatorId?: string;
    countryCode?: string;
    country?: string;
    billingTransactionId?: string;
    rateCost: number;
    mnc?: string;
    mcc?: string;
    totalCost: number;
    telcoBillJobState: TelcoBillJobState;
    telcoBillJobStateName?: string;
    queuedJobState: QueuedJobState;
    stateName?: string;
    processingOptions?: ProcessingOptions;
    smsPages: number;
    serviceProviderName?: string;
    smsProcessingListconfig?: SmsProcessingListconfig;
}
